import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthLayoutComponent } from '../auth-layout/auth-layout.component';
import { InputOtpComponent } from '@component/input-otp/input-otp.component';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  standalone: true,
  imports: [AuthLayoutComponent,InputOtpComponent,MatFormFieldModule],
  selector: 'app-restablecer-contrasena',
  templateUrl: 'restablecer-contrasena.component.html',
  styleUrls: ['./restablecer-contrasena.component.css']
})
export class RestablecerContrasenaComponent {

  constructor(
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
  ) {

  }


  onOtpComplete(otp: string) {
    console.log('OTP Completo:', otp);
  }

}
